import getRouteValue from "../../../src/js/utils/getRouteValue";
// ! rename the function to align with the widget name
export const customNavigation = () => {

    const el = document.querySelector('.curious-custom-navigation');
    if (!el) return;

    // ------------------------------------------------------------
    console.log('route Value', getRouteValue())
    class MLMenu {
      constructor(element, options = {}) {
        this.el = element;
        this.options = {
          // show breadcrumbs
          breadcrumbsCtrl: true,
          // initial breadcrumb text
          initialBreadcrumb: 'Menu',
          // show back button
          backCtrl: false,
          // delay between each menu item sliding animation
          itemsDelayInterval: 60,
          // direction 
          direction: 'r2l',
          // callback: item that doesn't have a submenu gets clicked
          // onItemClick([event], [inner HTML of the clicked item])
          onItemClick: (ev, itemName) => false,
          ...options
        };

        // the menus (<ul>s)
        this.menus = [...this.el.querySelectorAll('.menu__level')];
        // index of current menu
        this.current = getRouteValue();
        this.isAnimating = false;
        this.menusArr = [];
        this.backCtrl = null;
        this.breadcrumbsCtrl = null;

        this.init();
      }

      // Static method to check for animation support
      static get support() {
        return {
          animations: 'animation' in document.createElement('div').style ||
                    'webkitAnimation' in document.createElement('div').style ||
                    'mozAnimation' in document.createElement('div').style ||
                    'msAnimation' in document.createElement('div').style
        };
      }

      // Static method to get animation end event name
      static get animationEndEvent() {
        const animations = {
          'animation': 'animationend',
          'webkitAnimation': 'webkitAnimationEnd',
          'mozAnimation': 'animationend',
          'msAnimation': 'MSAnimationEnd'
        };

        const element = document.createElement('div');
        for (const animation in animations) {
          if (element.style[animation] !== undefined) {
            return animations[animation];
          }
        }
        return 'animationend';
      }

      // Modern animation end handler using Promises
      onEndAnimation(element) {
        return new Promise((resolve) => {
          if (!MLMenu.support.animations) {
            resolve();
            return;
          }

          const handleAnimationEnd = (event) => {
            if (event.target === element) {
              element.removeEventListener(MLMenu.animationEndEvent, handleAnimationEnd);
              resolve();
            }
          };

          element.addEventListener(MLMenu.animationEndEvent, handleAnimationEnd);
        });
      }

      // Modern class toggle methods
      addClass(element, className) {
        element.classList.add(className);
      }

      removeClass(element, className) {
        element.classList.remove(className);
      }

      hasClass(element, className) {
        return element.classList.contains(className);
      }

      init() {
        // iterate the existing menus and create an array of menus
        this.menus.forEach((menuEl, pos) => {
          const menu = {
            menuEl,
            menuItems: [...menuEl.querySelectorAll('.menu__item')]
          };
          this.menusArr.push(menu);

          // set current menu class
          if (pos === this.current) {
            this.addClass(menuEl, 'menu__level--current');
          }
        });

        // create back button
        if (this.options.backCtrl) {
          this.createBackButton();
        }

        // create breadcrumbs
        if (this.options.breadcrumbsCtrl) {
          this.createBreadcrumbs();
        }

        // event binding
        this.initEvents();
      }

      createBackButton() {
        this.backCtrl = document.createElement('button');
        this.backCtrl.className = 'menu__back menu__back--hidden';
        this.backCtrl.setAttribute('aria-label', 'Go back');
        this.backCtrl.innerHTML = '<span class="icon icon--arrow-left"></span>';
        this.el.insertBefore(this.backCtrl, this.el.firstChild);
      }

      createBreadcrumbs() {
        this.breadcrumbsCtrl = document.createElement('nav');
        this.breadcrumbsCtrl.className = 'menu__breadcrumbs';
        this.el.insertBefore(this.breadcrumbsCtrl, this.el.firstChild);
        
        // Build breadcrumb chain up to current level
        this.buildInitialBreadcrumbs();
      }

      buildInitialBreadcrumbs() {
        // Always add the initial breadcrumb (level 0)
        this.addBreadcrumb(0);
        
        // If we're not at the root level, we need to build the breadcrumb chain
        if (this.current > 0) {
          // Get the menu name from the current route
          const menuName = this.getMenuNameFromRoute();
          
          if (menuName) {
            // Set the name for the current menu so addBreadcrumb can use it
            this.menusArr[this.current].name = menuName;
            this.addBreadcrumb(this.current);
          }
        }
      }

      getMenuNameFromRoute() {
        const pathname = window.location.pathname;
        
        // Extract menu name from the route
        if (pathname === '/about' || pathname.startsWith('/about/')) {
          return 'About';
        } else if (pathname === '/collections' || pathname.startsWith('/collections/')) {
          return 'Collections';
        } else if (pathname === '/sonatas' || pathname.startsWith('/sonatas/')) {
          return 'Sonatas';
        } else if (pathname === '/discussion' || pathname.startsWith('/discussion/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/general' || pathname.startsWith('/discussions/category/general/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/methodology' || pathname.startsWith('/discussions/category/methodology/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/biography' || pathname.startsWith('/discussions/category/biography/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/collections' || pathname.startsWith('/discussions/category/collections/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/methodology' || pathname.startsWith('/discussions/category/methodology/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/sonatas' || pathname.startsWith('/discussions/category/sonatas/')) {
          return 'Discussion';
        } else if (pathname === '/discussions/category/performance' || pathname.startsWith('/discussions/category/performance/')) {
          return 'Discussion';
        }

        return null;
      }

      initEvents() {
        // Add click events to menu items
        this.menusArr.forEach((menu, menuIndex) => {
          menu.menuItems.forEach((item, itemIndex) => {
            const link = item.querySelector('a');
            if (link) {
              link.addEventListener('click', (ev) => this.handleMenuItemClick(ev, itemIndex));
            }
          });
        });

        // back navigation
        if (this.options.backCtrl && this.backCtrl) {
          this.backCtrl.addEventListener('click', () => this.back());
        }
      }

      handleMenuItemClick(event, clickPosition) {
        const submenu = event.target.getAttribute('data-submenu');
        const itemName = event.target.innerHTML;
        const subMenuEl = submenu ? this.el.querySelector(`ul[data-menu="${submenu}"]`) : null;

        // check if there's a sub menu for this item
        if (submenu && subMenuEl) {
          event.preventDefault();
          // open it
          this.openSubMenu(subMenuEl, clickPosition, itemName);
        } else {
          // remove current class from other links
          const currentLink = this.el.querySelector('.menu__link--current');
          if (currentLink) {
            this.removeClass(currentLink, 'menu__link--current');
          }
          this.addClass(event.target, 'menu__link--current');

          // callback
          this.options.onItemClick(event, itemName);
        }
      }

      async openSubMenu(subMenuEl, clickPosition, subMenuName) {
        if (this.isAnimating) {
          return false;
        }
        this.isAnimating = true;

        // save "parent" menu index for back navigation
        const subMenuIndex = this.menus.indexOf(subMenuEl);
        this.menusArr[subMenuIndex].backIdx = this.current;
        // save "parent" menu's name
        this.menusArr[subMenuIndex].name = subMenuName;

        // current menu slides out
        this.menuOut(clickPosition);
        // next menu (submenu) slides in
        await this.menuIn(subMenuEl, clickPosition);
      }

      async back() {
        if (this.isAnimating) {
          return false;
        }
        this.isAnimating = true;

        // current menu slides out
        this.menuOut();
        // next menu (previous menu) slides in
        const backMenu = this.menusArr[this.menusArr[this.current].backIdx].menuEl;
        await this.menuIn(backMenu);

        // remove last breadcrumb
        if (this.options.breadcrumbsCtrl && this.breadcrumbsCtrl.lastElementChild) {
          this.breadcrumbsCtrl.removeChild(this.breadcrumbsCtrl.lastElementChild);
        }
      }

      menuOut(clickPosition) {
        // the current menu
        const currentMenu = this.menusArr[this.current].menuEl;
        const isBackNavigation = typeof clickPosition === 'undefined';

        // slide out current menu items - first, set the delays for the items
        this.menusArr[this.current].menuItems.forEach((item, pos) => {
          const delay = isBackNavigation 
            ? pos * this.options.itemsDelayInterval
            : Math.abs(clickPosition - pos) * this.options.itemsDelayInterval;
          
          item.style.setProperty('--animation-delay', `${delay}ms`);
          item.style.animationDelay = `${delay}ms`;
        });

        // animation class
        const animationClass = this.options.direction === 'r2l'
          ? (!isBackNavigation ? 'animate-outToLeft' : 'animate-outToRight')
          : (isBackNavigation ? 'animate-outToLeft' : 'animate-outToRight');

        this.addClass(currentMenu, animationClass);
      }

      async menuIn(nextMenuEl, clickPosition) {
        const currentMenu = this.menusArr[this.current].menuEl;
        const isBackNavigation = typeof clickPosition === 'undefined';
        const nextMenuIdx = this.menus.indexOf(nextMenuEl);
        const nextMenuItems = this.menusArr[nextMenuIdx].menuItems;
        const nextMenuItemsTotal = nextMenuItems.length;

        // slide in next menu items - first, set the delays for the items
        nextMenuItems.forEach((item, pos) => {
          const delay = isBackNavigation 
            ? pos * this.options.itemsDelayInterval
            : Math.abs(clickPosition - pos) * this.options.itemsDelayInterval;
          
          item.style.setProperty('--animation-delay', `${delay}ms`);
          item.style.animationDelay = `${delay}ms`;
        });

        // calculate the index of the farthest item
        const farthestIdx = (clickPosition <= nextMenuItemsTotal / 2 || isBackNavigation) 
          ? nextMenuItemsTotal - 1 
          : 0;

        // animation class
        const animationClass = this.options.direction === 'r2l'
          ? (!isBackNavigation ? 'animate-inFromRight' : 'animate-inFromLeft')
          : (isBackNavigation ? 'animate-inFromRight' : 'animate-inFromLeft');

        this.addClass(nextMenuEl, animationClass);

        // wait for the farthest item animation to complete
        if (nextMenuItems[farthestIdx]) {
          await this.onEndAnimation(nextMenuItems[farthestIdx]);
        }

        // reset classes
        const outClass = this.options.direction === 'r2l'
          ? (!isBackNavigation ? 'animate-outToLeft' : 'animate-outToRight')
          : (isBackNavigation ? 'animate-outToLeft' : 'animate-outToRight');

        this.removeClass(currentMenu, outClass);
        this.removeClass(nextMenuEl, animationClass);
        this.removeClass(currentMenu, 'menu__level--current');
        this.addClass(nextMenuEl, 'menu__level--current');

        // reset current
        this.current = nextMenuIdx;

        // control back button and breadcrumbs navigation elements
        if (!isBackNavigation) {
          // show back button
          if (this.options.backCtrl && this.backCtrl) {
            this.removeClass(this.backCtrl, 'menu__back--hidden');
          }
          
          // add breadcrumb
          this.addBreadcrumb(nextMenuIdx);
        } else if (this.current === 0 && this.options.backCtrl && this.backCtrl) {
          // hide back button
          this.addClass(this.backCtrl, 'menu__back--hidden');
        }

        // we can navigate again
        this.isAnimating = false;
      }

      addBreadcrumb(idx) {
        if (!this.options.breadcrumbsCtrl || !this.breadcrumbsCtrl) {
          return false;
        }

        const bc = document.createElement('a');
        bc.innerHTML = idx ? this.menusArr[idx].name : this.options.initialBreadcrumb;
        bc.href = '#';
        this.breadcrumbsCtrl.appendChild(bc);

        bc.addEventListener('click', async (ev) => {
          ev.preventDefault();

          // do nothing if this breadcrumb is the last one in the list of breadcrumbs
          if (!bc.nextSibling || this.isAnimating) {
            return false;
          }
          this.isAnimating = true;

          // current menu slides out
          this.menuOut();
          // next menu slides in
          const nextMenu = this.menusArr[idx].menuEl;
          await this.menuIn(nextMenu);

          // remove breadcrumbs that are ahead
          while (bc.nextSibling) {
            this.breadcrumbsCtrl.removeChild(bc.nextSibling);
          }
        });
      }

      // Public methods for external control
      getCurrentMenu() {
        return this.current;
      }

      getCurrentMenuElement() {
        return this.menusArr[this.current].menuEl;
      }

      goToMenu(menuIndex) {
        if (menuIndex >= 0 && menuIndex < this.menusArr.length && menuIndex !== this.current) {
          const targetMenu = this.menusArr[menuIndex].menuEl;
          this.menuIn(targetMenu);
        }
      }

      destroy() {
        // Remove event listeners and clean up
        this.menusArr.forEach((menu) => {
          menu.menuItems.forEach((item) => {
            const link = item.querySelector('a');
            if (link) {
              // Clone and replace to remove all event listeners
              const newLink = link.cloneNode(true);
              link.parentNode.replaceChild(newLink, link);
            }
          });
        });

        if (this.backCtrl) {
          this.backCtrl.remove();
        }

        if (this.breadcrumbsCtrl) {
          this.breadcrumbsCtrl.remove();
        }
      }
    }

    // Export for use in modules
    if (typeof module !== 'undefined' && module.exports) {
      module.exports = MLMenu;
    } else if (typeof window !== 'undefined') {
      window.MLMenu = MLMenu;
    }

    let mymenu = document.querySelector('#menu-sidebar-menu')
    const mlmenu = new MLMenu(mymenu)
    window.mlmenu = mlmenu

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}